// src/pages/AdsLogin/components/detailComponents/PermissionPolicyFull.jsx
import React from "react";
import alarm from "../../../../assets/icons/Permission/notification_subtle.svg";
import disk from "../../../../assets/icons/Permission/disk_subtle.svg";
import camera from "../../../../assets/icons/Permission/camera_subtle.svg";
import gallery from "../../../../assets/icons/Permission/photo_subtle.svg";

export default function PermissionPolicyFull() {
  const items = [
    { icon: alarm,   t: "알림",           d: "필수 알림과 마케팅 정보 안내" },
    { icon: disk,    t: "저장공간",       d: "이미지, 미디어, 파일 저장 및 업로드" },
    { icon: camera,  t: "카메라",         d: "이미지 촬영 및 이미지 불러오기" },
    { icon: gallery, t: "사진 및 동영상", d: "촬영한 이미지 업로드 서비스" },
  ];

  return (
    <article className="prose prose-sm max-w-none">
      <header className="mb-4">
        <h2 className="text-t2 text-text-default">
          wizMarket 이용을 위해
        </h2>
        <h2 className="text-t2 text-text-default">
          아래 권한 허용이 필요해요
        </h2>
        <p className="text-b1 text-text-subtler pt-2">
          고객님께 나은 서비스를 제공하기 위해 사용됩니다.
          허용하지 않으셔도 기본 서비스 이용하실 수 있으나,
          일부 서비스 이용이 제한 될 수 있습니다.
        </p>
      </header>

      <section className="bg-[#F5F6F9] h-[16px]"></section>

      <section className="pt-6">
        

        <div className="space-y-4">
          {items.map((item) => (
            <div className="flex items-start gap-4" key={item.t}>
              <div className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-50">
                <img src={item.icon} alt={item.t} />
              </div>
              <div className="flex flex-col">
                <div className="text-sm font-semibold text-gray-900 pb-0.5">
                  {item.t}
                </div>
                <p className="text-sm text-gray-600">
                  {item.d}
                </p>
              </div>
            </div>
          ))}
        </div>

        
      </section>
    </article>
  );
}
